import {
    AfterViewInit, Attribute, ChangeDetectorRef, Directive, ElementRef, Host, Input, OnChanges, Optional, Renderer2,
    SimpleChanges
} from '@angular/core';

import {NgFormControlErrorsContent} from './ng-form-control-errors-content';
export class NgFormControlErrorsInvalid implements AfterViewInit, OnChanges {

    classes: string[] = [];
/**
 * @param {?} element
 * @param {?} renderer
 * @param {?} cdr
 * @param {?} hasClasses
 * @param {?} controlErrorsContent
 */
constructor(private element: ElementRef,
private renderer: Renderer2,
private cdr: ChangeDetectorRef,
private hasClasses: string,
private controlErrorsContent: NgFormControlErrorsContent) {

        if (!this.controlErrorsContent) {
            throw new Error(
                'control-errors must be used with a parent .control-errors-content directive');
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.controlErrorsContent.onChange$.subscribe(() => this.update());
    }
/**
 * @param {?} data
 * @return {?}
 */
set controlErrorsInvalid(data: string[] | string) {
        const /** @type {?} */ classes = Array.isArray(data) ? data : data.split(' ');
        this.classes = classes.filter(c => !!c);
    }
/**
 * @return {?}
 */
update(): void {
        this.classes.forEach((c: string) => {
            if (!this.hasClass(c) && this.invalid) {
                this.renderer.addClass(this.element.nativeElement, c);
            } else {
                this.renderer.removeClass(this.element.nativeElement, c);
            }
        });

        this.cdr.markForCheck();
    }
/**
 * @param {?} className
 * @return {?}
 */
hasClass(className: string): boolean {
        if (!this.hasClasses) {
            return false;
        }

        return this.hasClasses.includes(className);
    }
/**
 * @return {?}
 */
get invalid(): boolean {
        return this.controlErrorsContent.invalid;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[controlErrorsInvalid]',
    exportAs: 'controlErrorsInvalid',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ChangeDetectorRef, },
{type: undefined, decorators: [{ type: Optional }, { type: Attribute, args: ['class', ] }, ]},
{type: NgFormControlErrorsContent, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'controlErrorsInvalid': [{ type: Input },],
};
}

function NgFormControlErrorsInvalid_tsickle_Closure_declarations() {
/** @type {?} */
NgFormControlErrorsInvalid.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgFormControlErrorsInvalid.ctorParameters;
/** @type {?} */
NgFormControlErrorsInvalid.propDecorators;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.classes;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.element;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.renderer;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.cdr;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.hasClasses;
/** @type {?} */
NgFormControlErrorsInvalid.prototype.controlErrorsContent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
